import tooltips from '../../helpers/tooltips'

describe('tooltips', () => {
  describe('#getTooltip', () => {
    it('should predefined topic list tooltip text', () => {
      expect(tooltips.getTooltip('Business Website')).toEqual('URL link to website if applicable')
      expect(tooltips.getTooltip('random')).toEqual('')
    })
  })
})